import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './GenerateCallScoreButton.scss';
import { ReactComponent as SparkleIcon } from "../../assets/icons/Sparkle.svg";
import { generateCallScoreForExistingConversation, fetchJobStatus, fetchCallScore } from '../../services/callScore'
import { RotatingLines } from "react-loader-spinner";

const GenerateCallScoreButton = ({ conversationId = '', setFinalConversationId }) => {
    const location = useLocation();
    const navigate = useNavigate();
  
    const [isLoading, setIsLoading] = useState(false);
    const [jobStatus, setJobStatus] = useState('');
    const [buttonText, setButtonText] = useState('Generate Call Score');
    const [callScore, setCallScore] = useState(null);

    const generateCallScore = async () => {
        if (isLoading) {
            return;
        }

        setButtonText('Processing Call Score...');
        setIsLoading(true);

        try {
            await generateCallScoreForExistingConversation(conversationId);
        } catch (e) {
            console.error('Error generating call score:', e);
            setButtonText('Generate Call Score');
            setIsLoading(false);
            return;
        }
    };

    const viewCallScore = () => {
        setFinalConversationId(null)
        navigate('/view-call-score', { state: { callScore, conversationId } });
    }

    useEffect(() => {
        let intervalId;

        const checkStatus = async () => {
            try {
                const response = await fetchJobStatus(conversationId);
                console.log('Job status:', response.status);
                setJobStatus(response.status);

                if (response.status === "completed") {
                    clearInterval(intervalId);

                    setButtonText('Almost ready!')
                    const callscoreData = await fetchCallScore(conversationId);
                    setCallScore(callscoreData);

                    setIsLoading(false);
                    setButtonText('View Call Score');
                } else if (response.status === 'failed') {
                    clearInterval(intervalId);
                    setIsLoading(false);
                    setButtonText('Error: Try Again');
                }
            } catch (error) {
                console.error('Error checking job status:', error);
                clearInterval(intervalId);
                setIsLoading(false);
                setButtonText('Error: Try Again');
                setJobStatus('error');
            }
        };

        if (isLoading) {
            intervalId = setInterval(checkStatus, 5000); // Check every 5 seconds
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isLoading, conversationId]);

    if (location.pathname !== '/real-time-assist') {
      return null;
    }
  
    return (
        <button 
            className={`blue-button ${!!callScore ? 'generate-call-score-button' : ''}`}
            onClick={jobStatus === 'completed' ? viewCallScore : generateCallScore} 
        >
            <p>{buttonText}</p>
            <div className="my-button">
            {isLoading ? <RotatingLines strokeColor="white" strokeWidth="2" width="22" /> : <SparkleIcon style={{width: '20px'}}/>}
            </div>
        </button>
    );
};
  
export default GenerateCallScoreButton;